<template>
    <!-- TODO: Fix translation -->
    <b-modal
        id="add-project-modal"
        ref="add-project-modal"
        :title="addProjectString"
        :ok-title="$t('group.internship.create') + selectedStudentsCount"
        :cancel-title="$t('common.close')"
        cancel-variant="outline-primary"
        @ok="onOk"
        @show="onShow()"
        modal-class="apprentice-default-modal"
        size="lg">
        <div class="add-project">
            <b-alert
                v-if="foundErrors"
                show
                variant="danger">
                {{ $t('group.internship.title_cannot_be_empty_you_must_select_at_least_one_student') }}
            </b-alert>
            <div
                class="project-title-edit"
                v-if="![2, 6, 7].includes(groupIn.type_id)">
                <label for="add-project-name-input">{{ $t('common.title') }}:</label>
                <b-form-input
                    id="add-project-name-input"
                    v-model="name"
                    :placeholder="$t('common.title')"></b-form-input>
            </div>
            <div class="users-overview">
                <div
                    class="loading text-center"
                    v-if="loading">
                    <i class="fa fa-spinner fa-spin"></i>
                </div>
                <div
                    class="users"
                    v-else>
                    <label>{{ $t('group.internship.students_teachers') }} </label>
                    <design-2021-apprentice-data-table
                        class="projects-add-table"
                        :items="loadedUsers"
                        :fields="headers">
                        <template v-slot:options>
                            <b-button
                                class="btn-add btn-create-student"
                                v-b-modal="'school-account-add-user'"
                                variant="primary"
                                >{{ $t('group.internship.new_user') }}
                            </b-button>
                            <design-2021-school-accounts-add-account-modal-component @user-created="load()">
                            </design-2021-school-accounts-add-account-modal-component>
                        </template>

                        <template v-slot:cell(type)="data">
                            {{
                                data.item.type === 'student'
                                    ? $t('group.internship.student')
                                    : $t('group.internship.teacher')
                            }}
                        </template>

                        <template v-slot:cell(add_to_project)="data">
                            <div class="add_to_project">
                                <b-button
                                    class="btn-hand-pointer btn-user-selection-toggle"
                                    :class="data.item.selected && 'active'"
                                    variant="primary-icon-only"
                                    @click="userSelectionToggle(data.item)">
                                </b-button>
                                <!--                            <b-form-checkbox switch :key="data.item.id" v-model="data.item.selected"></b-form-checkbox>-->
                            </div>
                        </template>
                        <template v-slot:cell(create_new_project_for_user)="data">
                            <div
                                class="create_new_project_for_user"
                                v-if="data.item.type === 'student'">
                                <b-button
                                    class="btn-file-add btn-new-paper"
                                    v-b-tooltip.hover
                                    variant="primary-icon-only"
                                    :title="$t('group.internship.create_paper')"
                                    @click="createProjectForStudent(data.item.id)">
                                </b-button>
                            </div>
                        </template>
                    </design-2021-apprentice-data-table>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-group-show-add-project-modal-component',
    props: ['hasChildren', 'groupIn'],
    data() {
        return {
            name: null,
            loadedUsers: [],
            loading: false,
            headers: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                    sortable: true,
                },
                {
                    key: 'type',
                    label: 'Type',
                    sortable: true,
                },
                {
                    key: 'add_to_project',
                    label: this.$t('common.choose'),
                },
                {
                    key: 'create_new_project_for_user',
                    label: this.$t('common.actions'),
                },
            ],
            foundErrors: false,
        };
    },
    methods: {
        onOk(bvModalEvent) {
            this.foundErrors = false;
            if (this.hasErrors()) {
                bvModalEvent.preventDefault();
                this.foundErrors = true;
                return;
            }

            const data = {
                name: this.name,
                user_ids: this.loadedUsers.filter((user) => user.selected).map((user) => user.id),
            };

            this.$emit('project-added', data);
            this.name = null;
            const users = this.loadedUsers.filter((item) => {
                return data.user_ids.includes(item.id);
            });
            const students = users.filter((item) => {
                return item.type === 'student';
            });
            const studentIds = students.filter((user) => user.selected).map((user) => user.id);
            studentIds.forEach(this.removeFromLoadedUsers);
        },

        removeFromLoadedUsers(userId) {
            this.loadedUsers = this.loadedUsers.filter((x) => {
                return x.id !== userId;
            });
        },

        onShow() {
            this.name = null;
            this.foundErrors = false;

            if (!this.loadedUsers.length) {
                this.load();
            } else {
                this.loadedUsers = this.loadedUsers.map((user) => {
                    user.selected = false;
                    return user;
                });
            }
        },

        load() {
            this.loading = true;
            this.axios.get(this.routes.groupGetSchoolStudentsLeft(this.groupIn.id)).then(
                (response) => {
                    this.loadedUsers = response.data.map((user) => {
                        user.selected = false;
                        return user;
                    });

                    this.loading = false;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        createProjectForStudent(studentId) {
            const data = {
                name: this.loadedUsers.find((student) => student.id === studentId).full_name,
                user_ids: [studentId],
            };
            this.$emit('project-added', data);
            this.name = null;
            this.removeFromLoadedUsers(studentId);
        },

        clearLoadedUsers() {
            this.loadedUsers = [];
        },

        userSelectionToggle(user) {
            this.loadedUsers = this.loadedUsers.map((loadedUser) => {
                if (loadedUser.id === user.id) {
                    loadedUser.selected = !loadedUser.selected;
                }

                return loadedUser;
            });
        },

        hasErrors() {
            return ![2, 6, 7].includes(this.groupIn.type_id) && (!this.name || this.selectedStudents.length === 0);
        },
    },
    //${selectedStudentsCount === 1 ? 'leerling' : 'leerlingen'}, ${selectedTeachersCount} ${selectedTeachersCount === 1 ? 'docent' : 'docenten'}
    computed: {
        selectedStudentsCount() {
            let students = 0;
            let teachers = 0;
            if (this.loadedUsers.length) {
                for (const user of this.loadedUsers) {
                    if (user.selected) {
                        if (user.type === 'student') {
                            students++;
                        } else {
                            teachers++;
                        }
                    }
                }
            }
            const studentString =
                students === 1 ? this.$t('group.internship.student') : this.$t('group.internship.students');
            const teacherString =
                teachers === 1 ? this.$t('group.internship.teacher') : this.$t('group.internship.teachers');
            return students + ' ' + studentString + ', ' + teachers + ' ' + teacherString;
        },
        selectedStudents() {
            return this.loadedUsers.filter((user) => user.selected && user.type === 'student');
        },
        addProjectString() {
            switch (this.groupIn.type_id) {
                case 1:
                    return this.$t('group.new_project');
                default:
                    return this.$t('group.add_student');
            }
        },
    },
};
</script>

<style scoped lang="scss">
.projects-add-table ::v-deep {
    .add_to_project {
        .btn-user-selection-toggle {
            color: var(--primary);
            filter: grayscale(1);

            &:hover,
            &.active {
                filter: grayscale(0);
            }
        }
    }
}

::v-deep .apprentice-data-table tbody .btn-new-paper {
    font-size: 28px;
}
</style>
